import { ItemWithLabel } from '../../components';

const currencies: Currency[] = [
  { value: 'USD', label: 'USD ($)', char: '$' },
  { value: 'GBP', label: 'POUND (£)', char: '£' },
  { value: 'EUR', label: 'EURO (€)', char: '€' },
];

export function getCurrencies(): Currency[] {
  return currencies;
}

export function getCurrency(code: string): Currency | Partial<Currency> {
  return currencies.find((c) => c.value === code) || {};
}

interface Currency extends ItemWithLabel {
  char: string;
}
